import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { CuisineTypeDetailsPage, CuisineTypesPage } from './pages'

const CuisineTypesRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.CUISINE_TYPES.link}
      permissions={[PERMISSIONS.METADATA_TREE.LIST]}
      component={CuisineTypesPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.CUISINE_TYPE_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={CuisineTypeDetailsPage}
    />
  </Switch>
)

export default CuisineTypesRouter
